/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type PropertyMarketingType = typeof PropertyMarketingType[keyof typeof PropertyMarketingType];


export const PropertyMarketingType = {
  sale: 'sale',
  rent: 'rent',
} as const;
